<template>
  <div id="pageRoot">
    <img id="bg" src="/pages/img/sordovio/svgVio35bg.svg" />

        <span class="normalTheme pageInstruction" style="left: 55px; top: 55px;">
      <p>Escucha la lectura en voz alta de los siguientes enunciados.</p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 55px; top: 95px;">
      <p>Presta atención a las expresiones destacadas.</p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 55px; top: 135px;">
      <p>Marca la opción correcta.</p>
    </span>

    <p class="textBase" style="top: 200px; left: 45px; font-size:32px; position: absolute; line-height: 48px;">LOS GRILLOS LEVANTAN <span class="highlight">LIGERAMENTE LAS ALAS.</span></p>

    <p class="textBase" style="top: 280px; left: 45px; font-size:32px; position: absolute; color: #1FA5A5">ES LO MISMO QUE DECIR</p>


    <label class="toggleButtonContainer pageElement" id="toggle01"
      >los grillos levantan muy alto las alas.
      <input type="radio" name="grillos" 
      ref="1-1" 
      v-on:change="saveOption('radios', 1, 1)" 
      :onload="loadOption('radios', 1, 1)"/>
      <span class="toggleButton"></span>
    </label>
    <label class="toggleButtonContainer pageElement" id="toggle02"
      >los grillos levantan apenas las alas.
      <input type="radio" name="grillos" 
      ref="1-2" 
      v-on:change="saveOption('radios', 1, 2)" 
      :onload="loadOption('radios', 1, 2)"/>
      <span class="toggleButton"></span>
    </label>
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 43px;
  top: 173px;
}
label {
  font-style: italic;
  text-transform: uppercase;
  font-size: 29px;
}
#toggle01 {
  position: absolute;
  left: 65px;
  top: 350px;
}
#toggle02 {
  position: absolute;
  left: 65px;
  top: 427px;
}
</style>
<script>
  export default {
    methods:{
      dbId(name, group){
        return `${this.$parent.pageID()}-${name}-${group}`
      },
      async loadOption(name, group, option) {
        var id = this.dbId(name, group);

        var value = await this.$db.options.get({
        id: id,
        }).catch(function(error){
        console.log("error getting option" + error);
        });
        if (value === undefined) return;
        console.log(value);

        this.$refs[group+"-"+option].checked=value.option==option;

        console.log("option loaded: " + id + ", option:" + option + ", selected:" + value.option);
      },
      saveOption(name, group, option) {
        var id = this.dbId(name, group);

        this.$db.options.put({
              id: id,
              option: option
          }).catch(function(error){
              console.log("error saving option" + error);
          });

        console.log("option saved: " + id + ", " + option);
      }
    }
  }
</script>